import common from "../../common";
import Quest from "./Quest";

export default class QuestMinigame extends Quest {
    /**
     * @param {string} id
     * @param {string} owner
     */
    constructor(id, owner) {
        super(id, owner);

        this._ivandoeSkins = [];
        this._duration = 0;
        this._score = 0;
        this._bestScore = 0;
        this._complete = false;
        this._running = false;
        this._bgm = null;
        this._bgmName = "music_minigame_find_challenge_loop";
        this._repressEnemyChase = false;
    }

    /**
     * @param {object} metadata
     */
    init(metadata) {
        super.init(metadata);

        this._duration = metadata.duration;
        this._ivandoeSkins = metadata.ivandoeSkins;
    }

    /**
     * @param {GameScene} game
     */
    onMinigameStart(game) {
        this._running = true;
        this._complete = false;
        if (!common.saveData.settings.musicMute) {
            P3.audio.playSound("music_minigame_complete_00");
        }
    }

    onMinigameTrackerCreated() {
        
    }

    /**
     * @param {GameScene} game
     */
    onMinigameUpdate(game) {
        if (this.isRunning) {
            if (this._bgm == null || !this._bgm.howl || !this._bgm.playing) {
                if (!common.saveData.settings.musicMute) {
                    this._bgm = P3.audio.playMusic(this._bgmName);
                }
            }
        }
    }

    /**
     * @param {GameScene} game
     */
    onMinigameEnd(game) {
        this._running = false;
        this._complete = true;
        if (!common.saveData.settings.musicMute) {
            P3.audio.playSound("music_minigame_complete");
        }
        P3.audio.stopMusic();
    }

    /**
     * @param {GameScene} game
     */
    onMinigameCancel(game) {
        this._running = false;
        if (!common.saveData.settings.musicMute) {
            P3.audio.playSound("music_minigame_incomplete");
        }
        P3.audio.stopMusic();
    }

    /**
     * @return {number}
     */
    get duration() {
        return this._duration;
    }

    /**
     * @return {number}
     */
    get score() {
        return this._score;
    }

    /**
     * @return {number}
     */
    get maxScore() {
        return this._maxScore;
    }

    /**
     * @param {number} value
     */
    set score(value) {
        this._score = Math.max(0, value);
    }

    /**
     * @return {number}
     */
    get bestScore() {
        return this._bestScore;
    }

    /**
     * @param {number} value
     */
    set bestScore(value) {
        value = Math.max(0, value);
        if (value > this._bestScore) {
            this._bestScore = value;
        }
    }

    /**
     * @return {boolean}
     */
    get complete() {
        return this._complete;
    }

    /**
     * @return {boolean}
     */
    get isRequirementsMet() {
        return this.complete;
    }

    /**
     * @return {boolean}
     */
    get isRunning() {
        return this._running;
    }

    /**
     * @return {string}
     */
    get bgmName() {
        return this._bgmName;
    }

    /**
     * @param {string} value
     */
    set bgmName(value) {
        this._bgmName = value;
    }

    /**
     * @return {Boolean}
     */
    get repressEnemyChase() {
        return this._repressEnemyChase;
    };

    /**
     * @return {}
     */
    get ivandoeSkins() {
        return this._ivandoeSkins;
    }
}